import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <p>{`Documentation for Team X1's backend services which provides the data to our front end.`}</p>
    <h2 {...{
      "id": "using-these-docs"
    }}>{`Using these docs`}</h2>
    <p>{`On the left-hand side you will see the following options:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Getting started`}</strong>{`, you are here now.`}</li>
      <li parentName="ul"><strong parentName="li">{`Users`}</strong>{`,  documentation for the endpoints relating to user management.`}</li>
      <li parentName="ul"><strong parentName="li">{`Images`}</strong>{`, documentation for endpoints relating to image management.`}</li>
      <li parentName="ul"><strong parentName="li">{`Parties`}</strong>{`, documentation for endpoints relating to parties.`}</li>
      <li parentName="ul"><strong parentName="li">{`Chat Service`}</strong>{`, documentation for our chat service.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      